import { RouteComponentProps } from 'react-router';

import { Protection } from 'app/components/common/protected-route/protection';

export class ProtectionForRouteService {
    public static isProtectedRoute(protections: Protection[], componentProps: RouteComponentProps<any>): boolean {
        return !!protections && protections.some((guard) => guard.isProtected(componentProps));
    }

    public static getRedirectUrl(protections: Protection[], componentProps: RouteComponentProps<any>): string {
        return protections.find((guard) => guard.isProtected(componentProps))!.redirectTo;
    }
}
